import React from "react";
import "./LoadingSquare.css";

interface LoadingSquareProps {
  height: string;
}

const LoadingSquare: React.FC<LoadingSquareProps> = ({ height }) => {
  return <div className="LoadingSquare d-flex d-inline-block flex-fill" style={{ height: height || "100%" }} />;
};

export default LoadingSquare;
